import * as solicitacoesStore from './store'

export function solicitacoesModule({ store }) {
  store.registerModule('solicitacoes', {
    ...solicitacoesStore,
    namespaced: true,
  })
}
